<mat-card appearance="outlined" class="se-ui-date-picker-content mat-card-width">
    <ng-container [ngSwitch]="inputType">
        <!-- DATE EDITOR -->
        <ng-container *ngSwitchCase="'DATE'">
            <form class="fix-editor">
                <mat-form-field class="ag-row fix-mat-form">
                    <input #dateInput matInput tabindex="0"
                           [formControl]="formControl"
                           [errorStateMatcher]="matcher"
                           [matDatepicker]="picker"
                           (keydown.space)="_onSpaceBar($event)"
                           (keydown.delete)="_onTimePickerKeydown({ev:$event, picker: 'date'})">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker panelClass="ag-custom-component-popup se-ui-dateTimePickerEditor"></mat-datepicker>
                </mat-form-field>
            </form>
        </ng-container>

        <!-- TIME EDITOR -->
        <ng-container *ngSwitchCase="'TIME'">
            <se-time-picker #seTimePicker class="cp-input" tabindex="0"
                            [timeFormat]="timeInputFormat"
                            [isWithLabel]="false"
                            [showIcon]="false"
                            [showResetButton]="false"
                            [time]="value"
                            (timeChange)="_updateModel($event)"
                            (timePickerKeyDown)="_onTimePickerKeydown($event)">
            </se-time-picker>
        </ng-container>

        <!-- DATE-TIME EDITOR -->
        <ng-container *ngSwitchCase="'DATE_TIME'" class="fix-editor">
            <se-datetime-picker #seDateTimePicker class="cp-input" tabindex="0"
                                [isWithLabel]="false"
                                [showResetButton]="false"
                                [dateTime]="value"
                                [customPanelClass]="'se-ui-dateTimePickerEditor'"
                                (dateTimePickerKeyDown)="_onTimePickerKeydown($event)"
                                (dateTimeChange)="_updateModel($event)"
                                >
            </se-datetime-picker>
        </ng-container>
    </ng-container>

</mat-card>


